// Shared helper that splits a list of language entries into a "favorites" group
// and the rest, preserving the input order within each group. Every language
// picker feeds its already-sorted options through this so favorites float to the
// top consistently while keeping their natural (common-first, then
// alphabetical) ordering among themselves.
export function partitionByFavorite<T>(
  items: T[],
  getName: (item: T) => string,
  favoriteSet: Set<string>,
): {favorites: T[]; others: T[]} {
  const favorites: T[] = [];
  const others: T[] = [];
  for (const item of items) {
    if (favoriteSet.has(String(getName(item) || '').trim())) {
      favorites.push(item);
    } else {
      others.push(item);
    }
  }
  return {favorites, others};
}
